import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TuVisionNuestraEstructura from "./sections/TuVisionNuestraEstructura";
import ShieldingAndCybersecurity from "./sections/ShieldingAndCybersecurity";
import NuestraIngenieriaWeb from "./sections/NuestraIngenieriaWeb";
import ElCaminoASuNuevoHogar from "./sections/ElCaminoASuNuevoHogar";
import SolutionsArchive from "./sections/SolutionsArchive";
import NuestraTrayectoria from "./sections/NuestraTrayectoria";
import IniciemosTuTransformacion from "./sections/IniciemosTuTransformacion";
import TodoLoQueTuNegocioNecesitaParaCrecerOnline from "./sections/TodoLoQueTuNegocioNecesitaParaCrecerOnline";
import Portfolio from "./sections/Portfolio";
import About from "./sections/About";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TuVisionNuestraEstructura />
      <TodoLoQueTuNegocioNecesitaParaCrecerOnline />
      <About />
      <ShieldingAndCybersecurity />
      <NuestraIngenieriaWeb />
      <ElCaminoASuNuevoHogar />
      <SolutionsArchive />
      <Portfolio />
      <NuestraTrayectoria />
      <IniciemosTuTransformacion />
      <Footer />
    </div>;
}